import {t} from 'i18next';
export interface GraphDataItem {
  data: string;
  color: string;
}
// Action menu types
export type ActionMenuItem = {
  id: string;
  label: string;
  onClick: (selectedItem?: string) => void;
  disabled?: boolean;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ActionFlags = {
  canOpenInWizard?: boolean;
  canRollback?: boolean;
  canCopy?: boolean;
  canDelete?: boolean;
};
// Metadata types
type MetaDataItem = {
  label: string;
  value: string;
};

type MetaDataInput = {
  uploaded: number;
  released: number;
  errors: number;
};
/**
 * Returns adjusted graph data based on the amount to subtract.
 * @param subtractAmount Number to subtract from 100 for the second segment.
 */
export const adjustGraphData = (subtractAmount: number): GraphDataItem[] => [
  {
    data: '100',
    color:
      'linear-gradient(90deg, #008D95 -22.17%, #5265FF 49.38%, #764CB6 120.94%)',
  },
  {
    data: (100 - subtractAmount).toString(),
    color: 'rgba(52, 70, 96, 1)',
  },
];

export const formatNumber = (num: number): string => num.toLocaleString();

export const generateMetaDataList = (data: MetaDataInput): MetaDataItem[] => [
  {label: 'Source', value: formatNumber(data.uploaded)},
  {label: 'Ingested', value: formatNumber(data.released)},
  {label: 'Errors', value: formatNumber(data.errors)},
];
export const formatDate = (input: string): string => {
  const date = new Date(input);

  if (Number.isNaN(date.getTime())) return 'Invalid Date';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
};
export function getStatusMessage(status: string): string {
  if (!status) return '';

  const lowerStatus = status.toLowerCase();

  if (lowerStatus.includes('failed')) {
    return t('common.status.failed');
  } else if (lowerStatus.includes('copy')) {
    return t('common.status.copied');
  } else if (lowerStatus.includes('catalog')) {
    return t('common.status.cataloged');
  } else {
    return status;
  }
}
